import React from 'react';
import styled from 'styled-components';
import getTextStyles from "../../../../utils/getTextStyles/getTextStyles.js";
import { variantPadding as dropdownVariantPadding } from "../../../advanced/Dropdown/DropdownMenuHeading.js";
import { selectMenuSharedDefaults } from "../constants.js";
var halfSpacing = 'calc(var(--spacing-1) / 2)';
var variantPadding = {
  small: "calc(var(--spacing-1) + ".concat(halfSpacing, ") calc(var(--spacing-1) + ").concat(halfSpacing, ") ").concat(halfSpacing),
  medium: dropdownVariantPadding.medium,
  large: dropdownVariantPadding.large
};
var StyledDropdownMenuHeading = styled.div.withConfig({
  componentId: "CL__sc-a424rc-0"
})(["", ";background-color:var(--surface-bkg-color);color:var(--border-color);cursor:default;padding:", ";position:sticky;top:0;word-wrap:break-word;"], getTextStyles.eyebrowText(), _ref => {
  var {
    $size
  } = _ref;
  return variantPadding[$size];
});
var GroupHeading = _ref2 => {
  var {
    id,
    data: {
      label
    },
    selectProps
  } = _ref2;
  var {
    fieldSize = selectMenuSharedDefaults.fieldSize
  } = selectProps;
  return /*#__PURE__*/React.createElement(StyledDropdownMenuHeading, {
    role: "heading",
    $size: fieldSize,
    id: id
  }, label);
};
export default GroupHeading;